import { axiosInstance } from "@src/api/axiosConfig";
import { sampleItemPath } from "@src/api/axiosPath";
import { StatusItemType } from "@src/types/item.type";
import { AxiosError } from "axios";
import { useQuery } from "react-query";

// VVIP 상태변경 매물
const fetchSampleItems = async (): Promise<StatusItemType[]> => {
    const { data } = await axiosInstance.get<StatusItemType[]>(sampleItemPath);
    return data;
};

export const useGetSampleItems = () => {
    return useQuery<StatusItemType[], AxiosError>(["sampleItems"], fetchSampleItems);
};
